/*
 * @Author: edvardchen
 * @Date:   2016-12-26 16:12:08
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2016-12-26 16:23:57
 */

import _ from 'lodash';

/**
 * 格式话展示播放时长
 * @param  {Number} duration 播放时长，单位为秒
 * @return {String}
 */
export default function humanizeDuration(duration) {
  const seconds = duration % 60;
  const minutes = Math.floor(duration / 60) % 60;
  const hours = Math.floor(duration / (60 * 60));

  const parts = [minutes, seconds];
  if (hours > 0) {
    parts.unshift(hours);
  }
  return parts.map((item) => _.padStart(item, 2, '0')).join(':');
}
